import script from "./Resume.vue?vue&type=script&setup=true&lang=ts"
export * from "./Resume.vue?vue&type=script&setup=true&lang=ts"

import "./Resume.vue?vue&type=style&index=0&id=e2660618&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.11_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2660618"]])

export default __exports__